<div class="page-layout blank p-24" fusePerfectScrollbar>
    <h2>{{ "SAMPLE.HELLO" | translate }}</h2>
</div>
